import { Box, Typography } from "@mui/material";
import React from "react";
import CategoryCard from "./CategoryCard";

const ListView = () => {
  // mockData.js
  const properties = [
    {
      id: 1,
      name: "Hilton Grand Vacations Club Ocean Enclave Myrtle Beach",
      location: "Downtown Myrtle Beach, Myrtle Beach",
      image:
        "https://media.istockphoto.com/id/641448082/photo/beautiful-tropical-beach-front-hotel-resort-with-swimming-pool-sunshine.jpg?s=612x612&w=0&k=20&c=9PyitcP743oS7oGAoSW8iGDjf1goapy40Ol7PcCNv24=",
      description:
        "Beachfront property featuring suites with kitchen and a large outdoor pool.",
      rating: 9.4,
      reviews: 1160,
      propertyHighlights: [
        "Air conditioning",
        "Cable TV",
        "Free parking",
        "Free Wi-Fi",
      ],
      roomFacilities: [
        "Kingsize doublebed",
        "Bathtub",
        "Rainshower with separate hand shower",
        "Airconditioning",
        "Desk and sitting area",
        "Television",
        "Phone",
        "Nespresso coffee machine",
        "Coffee and tea facilities",
        "Safe",
        "Small fridge",
        "Iron and Ironingboard",
        "Care products (including shampoo, conditioner, shower gel)",
        "Blowdryer",
      ],
    },
    {
      id: 2,
      name: "Marriott Resort & Spa, Palm Beach",
      location: "Palm Beach, Florida",
      image:
        "https://images.pexels.com/photos/338504/pexels-photo-338504.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      description:
        "Luxury resort with spa, private beach, and large infinity pool overlooking the ocean.",
      rating: 9.1,
      reviews: 842,
      propertyHighlights: ["Spa", "Private beach", "Restaurant", "Free Wi-Fi"],
      roomFacilities: [
        "King bed",
        "Balcony with sea view",
        "Mini bar",
        "Air conditioning",
        "Flat-screen TV",
        "Coffee machine",
        "Safe",
        "Bathtub",
        "Shower",
        "Luxury toiletries",
      ],
    },
    {
      id: 3,
      name: "Grand Hyatt, Tokyo",
      location: "Shinjuku, Tokyo, Japan",
      image:
        "https://plus.unsplash.com/premium_photo-1687960116497-0dc41e1808a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmVzb3J0fGVufDB8fDB8fHww",
      description:
        "Modern skyscraper hotel with panoramic city views, rooftop bar, and indoor pool.",
      rating: 8.9,
      reviews: 950,
      propertyHighlights: [
        "City views",
        "Rooftop bar",
        "Indoor pool",
        "Free Wi-Fi",
      ],
      roomFacilities: [
        "Double bed",
        "City view balcony",
        "Desk",
        "Television",
        "Mini fridge",
        "Air conditioning",
        "Coffee/tea facilities",
        "Safe",
        "Hairdryer",
      ],
    },
  ];

  return (
<>
 
  {/* Cards */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 2, // spacing between cards
    }}
  >
    {[...properties, ...properties]?.map((item) => (
      <CategoryCard key={item?.id} {...item} />
    ))}
  </Box>
</>

  );
};

export default ListView;
